//Format phone

export const formattedPhone = (input) => {
  const phoneInput = input?.replace(/\D/g, "");
  //Format input (509) 000-0000
  const match = phoneInput?.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return phoneInput;
};
